export default [
  {
    name: 'grow_2529_survey_create_limit',
  },
  {
    name: 'grow_2529_questions_per_form_survey',
  },
  {
    name: 'grow_2529_recurring_surveys',
  },
  {
    name: 'grow_2529_database_response_view',
  },
  {
    name: 'grow_2529_payment_qt',
  },
];
